const TIME_ZONE = 'America/Toronto';
export function localEventClock(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:TIME_ZONE,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
  return {date:`${parts.year}-${parts.month}-${parts.day}`,time:`${parts.hour}:${parts.minute}`};
}
export function validDate(date) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const d = new Date(`${date}T12:00:00Z`);
  return !isNaN(d) && d.toISOString().slice(0,10) === date && d.getUTCDay() === 4;
}
export function availableSlots(slots, now = new Date()) {
  const clock = localEventClock(now);
  return slots.filter(s=>s.available && validDate(s.date) && (s.date>clock.date || (s.date===clock.date && clock.time<'19:00'))).sort((a,b)=>a.date.localeCompare(b.date));
}
export function replacementUpdates(cart, oldKey, targetId, limit = null) {
  const old = cart.items.find(i=>i.key===oldKey);
  if (!old || String(old.variant_id)===String(targetId)) throw new Error('stale');
  const specialized = i=>Object.keys(i.properties||{}).length || i.selling_plan_allocation;
  if (specialized(old)) throw new Error('special');
  const matches = cart.items.filter(i=>String(i.variant_id)===String(targetId));
  if (matches.length>1 || matches.some(specialized)) throw new Error('special');
  const target = matches[0], quantity = old.quantity+(target?.quantity||0);
  if (limit!==null && quantity>limit) throw new Error('capacity');
  return {[old.key]:0,[target?.key||String(targetId)]:quantity};
}
const text = {
  fr:{previous:'Mois précédent',next:'Mois suivant',week:['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'],choose:'Sélectionnez un jeudi dans le calendrier.',selected:'Votre jeudi : ',time:'à 19 h',unavailable:'Indisponible',none:'Aucun prochain jeudi n’est annoncé. Appelez le 819-687-9721.',past:'La date au panier est passée ou indisponible. Choisissez un autre jeudi.',pending:'Cliquez sur « Mettre à jour la date » pour confirmer votre choix.',saving:'Mise à jour de la date…',error:'La date n’a pas pu être confirmée. Vérifiez le panier avant de réessayer.',capacity:'Le nombre de places disponibles est insuffisant pour ce jeudi.',special:'Pour modifier cette réservation, appelez le 819-687-9721.',stale:'Le panier a changé. Actualisez la page avant de choisir la date.'},
  en:{previous:'Previous month',next:'Next month',week:['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],choose:'Select a Thursday in the calendar.',selected:'Your Thursday: ',time:'at 7 p.m.',unavailable:'Unavailable',none:'No upcoming Thursday is announced. Call 819-687-9721.',past:'The date in your cart has passed or is unavailable. Choose another Thursday.',pending:'Click “Update the date” to confirm your choice.',saving:'Updating the date…',error:'The date could not be confirmed. Check your cart before trying again.',capacity:'There are not enough places available for this Thursday.',special:'To change this reservation, call 819-687-9721.',stale:'Your cart has changed. Refresh the page before choosing the date.'}
};
let updatingCart = false;
if (typeof customElements !== 'undefined' && !customElements.get('fo-thursday-calendar')) {
  customElements.define('fo-thursday-calendar', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.lang = this.dataset.lang==='en'?'en':'fr';
      this.w = text[this.lang];
      this.locale = this.lang==='en'?'en-CA':'fr-CA';
      this.mode = this.dataset.mode;
      this.form = this.closest('form');
      this.slots = JSON.parse(this.querySelector('[data-slots]').textContent);
      this.current = String(this.dataset.currentVariant||'');
      this.selected = this.mode==='cart' && availableSlots(this.slots).some(s=>String(s.id)===this.current) ? this.current : '';
      this.calendar = this.querySelector('[data-calendar]');
      this.status = this.querySelector('[data-selection]');
      this.error = this.querySelector('[data-error]');
      this.apply = this.querySelector('[data-apply]');
      this.input = this.querySelector('[data-variant-input]');
      const upcoming = availableSlots(this.slots);
      const initial = upcoming.find(s=>String(s.id)===this.selected)||upcoming[0];
      this.month = (initial?.date||localEventClock().date).slice(0,7);
      this.calendar.hidden = false;
      this.onClick = event=>{
        const day = event.target.closest('[data-slot]');
        if (day && !day.disabled) this.choose(day.dataset.slot);
        const nav = event.target.closest('[data-month-offset]');
        if (nav && !nav.disabled) this.navigate(Number(nav.dataset.monthOffset));
        if (event.target.closest('[data-apply]')) this.updateCart();
      };
      this.addEventListener('click',this.onClick);
      this.onSubmit = event=>{
        if (!this.validSelection()) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.showError(this.mode==='cart' && this.selected!==this.current ? this.w.pending : this.w.choose);
          this.querySelector('[data-slot]:not(:disabled)')?.focus();
        }
      };
      this.form?.addEventListener('submit',this.onSubmit,true);
      this.render();
    }
    disconnectedCallback() { this.form?.removeEventListener('submit',this.onSubmit,true); this.removeEventListener('click',this.onClick); this.ready=false; }
    validSelection() {
      return !updatingCart && !!this.selected && availableSlots(this.slots).some(s=>String(s.id)===this.selected) && (this.mode!=='cart'||this.selected===this.current);
    }
    label(slot) { return new Intl.DateTimeFormat(this.locale,{timeZone:'UTC',weekday:'long',year:'numeric',month:'long',day:'numeric'}).format(new Date(`${slot.date}T12:00:00Z`)); }
    showError(message) { this.error.textContent=message;this.error.hidden=!message; }
    choose(id) {
      if (updatingCart || !availableSlots(this.slots).some(s=>String(s.id)===id)) return;
      this.selected=id;
      if (this.input) {this.input.value=id;this.input.setAttribute('value',id);}
      this.showError('');
      this.render();
      this.querySelector(`[data-slot="${id}"]`)?.focus();
    }
    navigate(offset) {
      const [y,m]=this.month.split('-').map(Number);
      this.month=new Date(Date.UTC(y,m-1+offset,1)).toISOString().slice(0,7);
      this.render();
      this.querySelector(`[data-month-offset="${offset}"]`)?.focus();
    }
    render() {
      const slots=availableSlots(this.slots), byDate=new Map(slots.map(s=>[s.date,s]));
      const [y,m]=this.month.split('-').map(Number), start=new Date(Date.UTC(y,m-1,1));
      const monthName=new Intl.DateTimeFormat(this.locale,{timeZone:'UTC',month:'long',year:'numeric'}).format(start);
      const lastDay=new Date(Date.UTC(y,m,0)).getUTCDate(), leading=(start.getUTCDay()+6)%7;
      const prevDisabled=!slots.length||this.month<=slots[0].date.slice(0,7), nextDisabled=!slots.length||this.month>=slots.at(-1).date.slice(0,7);
      this.calendar.replaceChildren();
      const nav=document.createElement('div');nav.className='fo-thursday__nav';
      for (const offset of [-1,1]) {
        const b=document.createElement('button');b.type='button';b.dataset.monthOffset=offset;b.textContent=offset<0?'‹':'›';b.setAttribute('aria-label',offset<0?this.w.previous:this.w.next);b.disabled=updatingCart||(offset<0?prevDisabled:nextDisabled);
        if (offset===1) {const title=document.createElement('strong');title.className='fo-thursday__month';title.textContent=monthName;title.setAttribute('aria-live','polite');nav.append(title);}
        nav.append(b);
      }
      this.calendar.append(nav);
      const week=document.createElement('div');week.className='fo-thursday__week';week.setAttribute('aria-hidden','true');
      this.w.week.forEach(day=>{const span=document.createElement('span');span.textContent=day;week.append(span);});this.calendar.append(week);
      const days=document.createElement('div');days.className='fo-thursday__days';days.setAttribute('role','group');days.setAttribute('aria-label',monthName);
      for(let n=0;n<leading;n++){const empty=document.createElement('span');empty.className='fo-thursday__blank';empty.setAttribute('aria-hidden','true');days.append(empty);}
      for(let day=1;day<=lastDay;day++){
        const date=`${this.month}-${String(day).padStart(2,'0')}`, slot=byDate.get(date), b=document.createElement('button');b.type='button';b.textContent=day;b.disabled=updatingCart||!slot;
        b.setAttribute('aria-label',`${this.label({date})} ${slot?this.w.time:this.w.unavailable}`);
        if(slot){b.dataset.slot=String(slot.id);b.setAttribute('aria-pressed',String(slot.id)===this.selected?'true':'false');}
        days.append(b);
      }
      this.calendar.append(days);
      const choice=slots.find(s=>String(s.id)===this.selected);
      const original=this.slots.find(s=>String(s.id)===this.current && validDate(s.date));
      this.status.textContent=choice?`${this.w.selected}${this.label(choice)} ${this.w.time}`:!slots.length?this.w.none:this.mode==='cart'?`${original?this.label(original)+' '+this.w.time+'. ':''}${this.w.past}`:this.w.choose;
      if(this.mode==='cart') {this.apply.hidden=!choice||this.selected===this.current;this.apply.disabled=updatingCart;}
      if(this.mode==='product') this.form?.querySelectorAll('[data-add-to-cart]').forEach(b=>{b.disabled=!choice;});
    }
    async updateCart() {
      const slot=availableSlots(this.slots).find(s=>String(s.id)===this.selected);
      if(updatingCart||!slot||this.selected===this.current)return;
      updatingCart=true;this.apply.disabled=true;this.showError('');this.status.textContent=this.w.saving;
      const root=this.dataset.root.replace(/\/?$/,'/');
      try {
        const response=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'});
        if(!response.ok)throw new Error('error');
        const cart=await response.json(), updates=replacementUpdates(cart,this.dataset.lineKey,slot.id,slot.limit);
        const payload={updates};
        const note=this.form?.querySelector('textarea[name="note"]');
        if(note)payload.note=note.value;
        const changed=await fetch(`${root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
        if(!changed.ok)throw new Error('error');
        const after=await changed.json();
        if(after.items.some(i=>i.key===this.dataset.lineKey)||!after.items.some(i=>String(i.variant_id)===String(slot.id)))throw new Error('error');
        window.location.assign(`${root}cart`);
      } catch(error) {
        this.showError(this.w[error.message]||this.w.error);
        this.apply.disabled=false;
        this.status.textContent=this.w.pending;
      } finally {updatingCart=false;}
    }
  });
}
